import React, { useMemo } from 'react';
import cx from 'classnames';
import styles from './GridList.module.scss';
import { GridListProps } from './GridList.types'; 
import { ListItemType } from '../List/List.types';
import List from '../List';

const GridList = <T extends ListItemType>(props: GridListProps<T>) => {
  const { 
    className,
    component, 
    columns = 1, 
    data,
    gap,
    ...rest 
  } = props;

  // Add gridColumn to each item
  const updatedData = useMemo(() => {
    return data?.map((item): T => ({
      ...item,
      itemClassName: styles.gridListItem,
    }));
  }, [data]);

  return (
    <List
      {...rest}
      className={cx(styles.gridList, className)}
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap: gap,
      }}
      component={component}
      data={updatedData}
    />
  );
};

export default GridList;
